import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as actions from "../../actions/EmailAuthenticationActions";
import UrlHelper from "../../utilities/UrlHelper";
import ValidationHelper from "../../utilities/ValidationHelper";
import SetPassword from "./setPassword/SetPassword";
import CompleteAccountSetup from "./CompleteAccountSetup";
import ticketType from "../../entities/TicketType";

export class ConfirmUpgradeToVirtualUserPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            errorMessage: undefined
        };

        this.handleComplete = this.handleComplete.bind(this);
        this.onStartClick = this.onStartClick.bind(this);
    }

    componentDidMount() {
        import("./_styles.scss");
        const ticket = UrlHelper.getParameterByName("ticket");
        if (!ValidationHelper.isNullOrEmpty(ticket))
            this.props.validateUserTicket(ticket);
    }

    handleComplete(password) {
        const ticket = UrlHelper.getParameterByName("ticket");
        if (!ValidationHelper.isNullOrEmpty(ticket))
            this.props.upgradeToVirtualUser(ticket, password);
    }

    onStartClick() {
        if (this.props.redirectLocationOnSuccess)
            window.location = this.props.redirectLocationOnSuccess;
    }

    render() {
        if (this.props.redirectLocationOnError) {
            window.location = this.props.redirectLocationOnError;
        }

        const redirectLocationOnSuccess = this.props.redirectLocationOnSuccess;
        const title = "Last Step!";
        const text = `Click the Complete Account Setup button below to finish verifying your account and get started.`;
        return (
            <div>
                {!redirectLocationOnSuccess &&
                <SetPassword
                    passwordValidationUserData={this.props.passwordValidationUserData}
                    passwordRequirements={this.props.passwordRequirements}
                    onComplete={this.handleComplete}
                    serverError={this.props.errorMessage}
                    isPasswordSetting={this.props.isPasswordSetting}
                    email={this.props.email}/>
                }
                {redirectLocationOnSuccess &&
                <CompleteAccountSetup
                    title={title}
                    text={text}
                    onComplete={this.onStartClick}
                    email={this.props.email}
                    completeButtonTitle="Complete Account Setup"/>}
            </div>
        );
    }
}

ConfirmUpgradeToVirtualUserPage.defaultProps = {
    validateUserTicket: () => {}
};

ConfirmUpgradeToVirtualUserPage.propTypes = {
    upgradeToVirtualUser: PropTypes.func,
    validateUserTicket: PropTypes.func,
    errorMessage: PropTypes.string,
    email: PropTypes.string,
    passwordValidationUserData: PropTypes.object,
    passwordRequirements: PropTypes.object,
    redirectLocationOnSuccess: PropTypes.string,
    redirectLocationOnError: PropTypes.string,
    isPasswordSetting: PropTypes.bool
};

const mapStateToProps = state => ({
    errorMessage: state.setPasswordState.errorMessage,
    email: state.setPasswordState.email,
    passwordValidationUserData: state.setPasswordState.passwordValidationUserData,
    passwordRequirements: state.setPasswordState.passwordRequirements,
    redirectLocationOnSuccess: state.setPasswordState.redirectLocationOnSuccess,
    redirectLocationOnError: state.setPasswordState.redirectLocationOnError,
    isPasswordSetting: state.setPasswordState.isPasswordSetting
});

const mapDispatchToProps = (dispatch) => {
    return ({
        upgradeToVirtualUser: (ticket, password) => dispatch(actions.upgradeToVirtualUser(ticket, password)),
        validateUserTicket: (ticket) => dispatch(actions.validateUserTicket(ticket, ticketType.user.upgradeToVirtualUser.value))
    });
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmUpgradeToVirtualUserPage);
